import axios from 'axios';

const newRequest = axios.create({
	baseURL: 'https://freelancerfinder-api.vercel.app/api/',
	withCredentials: true,
});

export default newRequest;
